import _ from "lodash";
import Vue from "vue";
import { getPurchaseTypes, getSalesTypes } from "./documentServices";

import CREATE_PARTITION_TAG from "../graphql/tag/CreatePartitionTag.gql";

import { apolloClient } from "@/apollo.services";

const dicoPartitionDocTypes = {
    Fixe_Variable: getPurchaseTypes(),
    genericPurchase: JSON.parse(JSON.stringify(getPurchaseTypes())),
    genericSales: getSalesTypes(),
};
const index = dicoPartitionDocTypes.genericPurchase.findIndex((s) => s === "WITHOUT_INVOICE");
if (index !== -1) {
    dicoPartitionDocTypes.genericPurchase.splice(index, 1);
}
const dicoPartitionColors = {
    Fixe_Variable: "tagFixeVariable",
    genericPurchase: "tagGenericPurchase",
    genericSales: "tagGenericSales",
    folder: "tagFolder",
    primaryLog: "tagLog",
};

function sortTags(tags) {
    tags.sort((a, b) => {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
    });
}

export function getTagColor(tag, partitionTag) {
    if (partitionTag?.uniqueName) {
        return dicoPartitionColors[partitionTag.uniqueName];
    } else if (tag?.primaryLog) {
        return dicoPartitionColors["primaryLog"];
    } else if (tag?.type === "SubAccountableAccount") {
        return "tagSubAccountableAccount";
    }
    return "tagFree";
}

export function getTagDocumentTypes(tag, partitionTag) {
    if (partitionTag) {
        return dicoPartitionDocTypes[partitionTag.uniqueName];
    } else if (tag?.primaryLog) {
        return [tag.primaryLog];
    }
    return [];
}

export function computeCompanyCommonTags(partitionTags, commonCompanyTags) {
    //
    for (const partitionTag of partitionTags) {
        commonCompanyTags.push({
            header: partitionTag.name,
            text: partitionTag.name,
            documentTypes: dicoPartitionDocTypes[partitionTag.uniqueName],
            primaryLog: partitionTag.primaryLog,
            partitionTag,
        });
        sortTags(partitionTag.tags);
        for (const tag of partitionTag.tags) {
            const color = getTagColor(tag, partitionTag);
            const documentTypes = getTagDocumentTypes(tag, partitionTag);
            commonCompanyTags.push({
                id: tag.id,
                text: tag.name,
                count: tag.count || undefined,
                type: tag.type,
                primaryLog: tag.primaryLog,
                color,
                partitionTag: partitionTag,
                documentTypes: documentTypes || undefined,
            });
        }
    }
}

export function getCompanyTags(component, companyId, tags, companyTags) {
    if (tags.length) {
        sortTags(tags);
        let partitionTags = tags
            .map((x) => ({ ...x.partitionTag, tags: [] }))
            .filter((x) => x.id && x.id !== null);
        partitionTags = _.uniqBy(partitionTags, "id");
        const withoutPartition = {
            id: "WithoutId",
            name: "Etiquettes libres",
            tags: [],
        };
        partitionTags.splice(0, 0, withoutPartition);
        tags.forEach((tag) => {
            let partition;
            if (tag?.partitionTag?.id) {
                partition = partitionTags.find((x) => x.id === tag.partitionTag.id);
                if (!partition) {
                    debugger;
                }
            } else if (tag.primaryLog) {
                partition = partitionTags.find((x) => x.primaryLog === tag.primaryLog);
                if (!partition) {
                    partition = {
                        id: "",
                        company: { id: companyId },
                        primaryLog: tag.primaryLog,
                        name: "Journal " + component.$t("document.type." + tag.primaryLog),
                        tags: [],
                    };
                    partitionTags.push(partition);
                }
            }
            if (!partition) {
                partition = withoutPartition;
            }
            partition.tags.push({
                id: tag.id,
                name: tag.name,
                type: tag.type,
                primaryLog: tag.primaryLog,
                count: tag.count || undefined,
                color: getTagColor(tag, partition),
                // tag.type === "SubAccountableAccount" ? "tagSubAccountableAccount": "tagFree",
            });
        });

        const index = partitionTags.findIndex((x) => x.id === "WithoutId");
        if (index >= 0 && index < partitionTags.length) {
            if (!partitionTags[index].tags.length) {
                partitionTags.splice(index, 1);
            }
        }
        partitionTags.sort((pa, pb) => {
            if ((pa.company && pb.company) || (!pa.company && !pb.company)) {
                if (pa.name < pb.name) return -1;
                if (pa.name > pb.name) return -1;
                return 0;
            } else if (pa.company && !pb.company) return -1;
            return 1;
        });
        computeCompanyCommonTags(partitionTags, companyTags);
    }
}

export async function createPartitionTag(
    companyId: string,
    companyScopeId: string,
    name: string,
    type: string,
) {
    const result = await apolloClient.mutate({
        mutation: CREATE_PARTITION_TAG,
        variables: {
            partitionName: name,
            company: companyId ? { connect: { id: companyId } } : undefined,
            companyScope: companyScopeId ? { connect: { id: companyScopeId } } : undefined,
            type,
        },
    });
    debugger;
    const newPartitionTag = result.data.createPartitionTag;
    return newPartitionTag;
}

// TreeView

export function formatTagsToTreeView(tags: FormatTreeViewInput[]) {
    const treeViewTags: FormatTreeViewOutput[] = [];
    tags.forEach((tag) => {
        treeViewTags.push({
            id: tag.id,
            name: tag?.partitionTag?.name ? `${tag.partitionTag.name}/${tag.name}` : tag.name,
            partitionTag: tag.partitionTag,
            type: tag.type,
            primaryLog: tag.primaryLog,
        });
    });
    return treeViewTags;
}

type FormatTreeViewInput = {
    id: string;
    name: string; // folderName2/.../fileName
    partitionTag: {
        id: string;
        name: string; // folderName1/
    };
} & { [key: string]: any };

type FormatTreeViewOutput = {
    id: string;
    name: string; // folderName1/folderName2/.../fileName
} & { [key: string]: any };
